import setupStore from './storeSetup';

const store = setupStore();

export default store;

export type LlinkidStore = typeof store;
export type LlinkidDispatch = typeof store.dispatch;
